import { useAtomValue } from 'jotai';
import { activeHomeTabAtom } from '../states/homeTab.atom';

/**
 * 지정한 screen_name의 탭이 현재 활성 상태인지 여부.
 * TabView renderScene 하위 컴포넌트에서 "내가 지금 보이는 탭인지" 체크할 때 사용.
 */
export const useIsTabFocused = (screenName: string): boolean => {
  const active = useAtomValue(activeHomeTabAtom);
  return active?.screen_name === screenName;
};
